/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Role } from "~/generated/graphql";

export const showRole = (role: Role): string => {
  switch (role) {
    case Role.Admin:
      return "Full access";
    case Role.TeamLead:
      return "Restricted access";
    case Role.ReadOnly:
      return "Read Only";
    default:
      return "Unknown";
  }
};
